/* eslint-disable @typescript-eslint/no-explicit-any */
import { Close, Save } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField,
} from "@mui/material";
import { Component } from "@pimo/pimo-app-builder";
import { useAppState } from "@pimo/pimo-app-builder/src/lib/app-state-context";
import { getLocalizedMessage } from "@pimo/pimo-l10n";
import { useState } from "react";

import {
  DragDropLayoutComponentLayoutProps,
  DragDropLayoutEditSchema,
} from "./types";

export const ComponentEditor: React.FC<{
  component?: Component<any, any, any, any, DragDropLayoutComponentLayoutProps>;
  editSchema: DragDropLayoutEditSchema;
  onChange: (value: Record<string, any>) => void;
  onClose: () => void;
  language?: string;
}> = ({ editSchema, onChange, component, onClose, language = "en" }) => {
  const appState = useAppState();
  const componentState = component?.stateMapper?.(appState) ?? {};
  const [componentValue, setComponentValue] =
    useState<Record<string, unknown>>(componentState);

  const handleSave = () => {
    onChange(componentValue);
  };

  const renderField = (field: {
    property: string;
    type: string;
    label?: string;
  }) => {
    const fieldLabel = field.label || field.property;

    switch (field.type) {
      case "boolean":
        return (
          <FormControlLabel
            control={
              <Checkbox
                checked={!!componentValue[field.property]}
                onChange={(e) => {
                  const newValue = {
                    ...componentValue,
                    [field.property]: e.target.checked,
                  };
                  setComponentValue(newValue);
                }}
                id={field.property}
                name={field.property}
              />
            }
            label={fieldLabel}
          />
        );
      default:
        return (
          <TextField
            fullWidth
            margin="normal"
            id={field.property}
            name={field.property}
            label={fieldLabel}
            type={field.type}
            value={(componentValue[field.property] as string) || ""}
            onChange={(e) => {
              const newValue = {
                ...componentValue,
                [field.property]: e.target.value,
              };
              setComponentValue(newValue);
            }}
          />
        );
    }
  };

  return (
    <Dialog open={true} onClose={onClose}>
      <DialogTitle>
        {getLocalizedMessage(language, "componentEditor.editComponent") ||
          "Edit Component"}
      </DialogTitle>
      <DialogContent>
        <form style={{ marginTop: "8px" }}>
          {editSchema.fields.map((field) => (
            <div key={field.property}>{renderField(field)}</div>
          ))}
          <Box
            sx={{ mt: 2, display: "flex", justifyContent: "flex-end", gap: 1 }}
          >
            <Button color="inherit" startIcon={<Close />} onClick={onClose}>
              {getLocalizedMessage(language, "componentEditor.cancel") ||
                "Cancel"}
            </Button>
            <Button color="primary" startIcon={<Save />} onClick={handleSave}>
              {getLocalizedMessage(language, "componentEditor.saveChanges") ||
                "Save Changes"}
            </Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
};
